module.exports = __webpack_public_path__ + "0fa3fbfb280a38d041ffe5f5c12cb8af.fbx";